var _circle, _circle2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 141,
    viewBox: "0 0 141 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 70.5,
    r: 70.5,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 70.5,
    r: 63.5,
    fill: "#7E42FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.923 35.9231C107.923 34.3846 107 34.0769 106.538 34.0769H74.6923C72.3846 34.0769 72.3846 36.3846 72.3846 36.3846V40.8461C72.3846 42.8461 73.6154 43.3077 74.2308 43.3077H96.3846C97.3077 43.4615 98.6923 44.0769 98.6923 46.5384V67.4615C98.8462 68.0769 99.1539 69.4615 101 69.4615H105.923C105.923 69.4615 107.923 69.4615 107.923 67.1538V35.9231Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6923 55.1538C88.8461 53.6153 87.7692 53.3076 87.3077 53.3076H55.4615C53.1538 53.3076 53.1538 55.6153 53.1538 55.6153V60.0768C53.1538 62.0768 54.3846 62.5384 55 62.5384H77.1538C78.0769 62.6922 79.4615 63.3076 79.4615 65.7692V86.6922C79.6153 87.3076 79.923 88.6922 81.7692 88.6922H86.6923C86.6923 88.6922 88.6923 88.6922 88.6923 86.3845V55.1538Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1539 106.077C39.4616 106.384 40.6923 107.308 42.3846 105.615L58.3846 89.6152C58.8462 89.1537 60.2308 88.0768 60.2308 90.2306V105.923C60.3846 106.538 60.6923 107.923 62.5385 107.923H67.4616C67.4616 107.923 69.4616 107.923 69.4616 105.615V74.3845C69.4616 72.846 68.5385 72.6922 68.0769 72.5383H36.2308C33.9231 72.5383 33.9231 74.846 33.9231 74.846V79.3076C33.9231 81.3076 35.1539 81.7691 35.7692 81.7691H50.5385C51.1539 81.7691 53 81.9229 51.3077 83.6153L35.9231 99.3076C35.9231 99.3076 34.0769 101 35.6154 102.538L39.1539 106.077Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar5);
export default __webpack_public_path__ + "static/media/avatar5.46ea8fad120a5095d9787041c51ec5ff.svg";
export { ForwardRef as ReactComponent };